import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const BrandsSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const brands = [
    {
      name: 'Pladur',
      logo: 'https://pladurbarcelona.es/images/marcas/marca-pladur.png',
    },
    {
      name: 'Placo',
      logo: 'https://pladurbarcelona.es/images/marcas/marca-placo.png',
    },
    {
      name: 'Knauf',
      logo: 'https://pladurbarcelona.es/images/marcas/marca-knauf.png',
    },
    {
      name: 'Isover',
      logo: 'https://pladurbarcelona.es/images/marcas/marca-isover.png',
    },
    {
      name: 'Danosa',
      logo: 'https://pladurbarcelona.es/images/marcas/marca-danosa.png',
    },
    {
      name: 'Promat',
      logo: 'https://pladurbarcelona.es/images/marcas/marca-promat.png',
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text-dark mb-4">
            Trabajamos con las mejores marcas
          </h2>
          <p className="text-text-light text-base sm:text-lg max-w-2xl mx-auto">
            Utilizamos materiales de primera calidad de fabricantes líderes
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 sm:gap-8">
          {brands.map((brand, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-xl p-6 sm:p-8 flex items-center justify-center hover:shadow-lg transition-shadow duration-300 border border-gray-100"
            >
              <img
                src={brand.logo}
                alt={`Marca ${brand.name}`}
                className="w-full h-auto max-h-12 sm:max-h-16 object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
